import { render, staticRenderFns } from "./TaxGroups.vue?vue&type=template&id=4abd0d85"
import script from "./TaxGroups.vue?vue&type=script&lang=js"
export * from "./TaxGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports